import Image from 'next/image';
import clsx from 'clsx';

import DogLabImage from '@/icons/images/dog-lab.png';
import { I18nTrans } from '@/lib/components/I18nTrans/I18nTrans';
import { normalizeImageSrc } from '@/lib/utils/normalizeImageSrc';

import styles from './DogHint.module.scss';

export function DogHint({ message }: { message: string }) {
  return (
    <div className={styles.wrapper}>
      <Image
        src={normalizeImageSrc(DogLabImage.src)}
        alt=""
        width="140"
        height="226"
        style={{
          height: 'auto',
          objectFit: 'contain',
        }}
      />
      <div className={clsx(styles.hint, 'text text-sm text-bold')}>
        <I18nTrans ns="home" i18nKey="dogHint">
          {message}
        </I18nTrans>
      </div>
    </div>
  );
}
